<template>
  <div>
    <v-autocomplete
      v-model="selected"
      :search-input.sync="search"
      :items="deviceList"
      item-text="topic"
      return-object
      label="Search with device id"
      placeholder="Search with device id"
      persistent-placeholder
      prepend-inner-icon="mdi-magnify"
      solo-inverted
      rounded
      hide-details
      hide-selected
      clearable
      flat
      color="primary"
      :loading="loading || loadingMore"
      @change="selectedDevice"
    >
      <template v-slot:append-item>
        <div
          v-if="hasMore && !search"
          v-intersect="onIntersect"
          style="height: 1px"
        ></div>

        <v-list-item v-if="loadingMore">
          <v-list-item-content>
            <v-list-item-title> Loading more devices... </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'search-menu',

  data() {
    return {
      selected: null,
      search: '',
      deviceList: [],
      loading: false,
      loadingMore: false,
      page: 1,
      limit: 20,
      hasMore: true
    };
  },

  watch: {
    async search(val) {
      if (val && val.length > 2) {
        await this.searchDevices(val);
      }

      if (!val) {
        await this.resetAndLoad();
      }
    }
  },

  methods: {
    selectedDevice(payload) {
      if (payload) {
        this.$router.push(`/${payload.deviceType}/${payload.topic}`);
      }
    },

    async fetchDevices() {
      if (this.loadingMore || !this.hasMore) {
        return;
      }

      this.loadingMore = true;

      try {
        const ecotronDevices =
          (await this.$store.dispatch('ecotron/fetchEcotronPage', {
            page: this.page,
            limit: this.limit
          })) || [];

        const ecofrostDevices =
          (await this.$store.dispatch('ecofrost/fetchEcofrostPage', {
            page: this.page,
            limit: this.limit
          })) || [];

        const newDevices = [...ecotronDevices, ...ecofrostDevices];

        if (newDevices.length === 0) {
          this.hasMore = false;
        } else {
          this.deviceList.push(...newDevices);
          this.page++;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingMore = false;
      }
    },

    async searchDevices(search) {
      this.loadingMore = true;

      try {
        const ecotronDevices =
          (await this.$store.dispatch('ecotron/fetchEcotronPage', {
            page: 1,
            limit: 20,
            search
          })) || [];

        const ecofrostDevices =
          (await this.$store.dispatch('ecofrost/fetchEcofrostPage', {
            page: 1,
            limit: 20,
            search
          })) || [];

        this.deviceList = [...ecotronDevices, ...ecofrostDevices];

        this.hasMore = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingMore = false;
      }
    },

    async resetAndLoad() {
      this.page = 1;
      this.deviceList = [];
      this.hasMore = true;

      await this.fetchDevices();
    },

    onIntersect(entries, observer, isIntersecting) {
      if (isIntersecting && !this.search) {
        this.fetchDevices();
      }
    }
  },

  async created() {
    this.loading = true;

    try {
      await this.fetchDevices();
    } finally {
      this.loading = false;
    }
  }
};
</script>
